import * as React from "react";

function SvgIcons8AppleLogo(props, ref) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 48 48" {...{ ...props, ref }}>
      <path
        fill="#42A5F5"
        d="M40.084 32.613c-.848 1.835-1.254 2.655-2.342 4.274-1.521 2.264-3.67 5.089-6.326 5.109-2.361.018-2.971-1.507-6.176-1.482-3.204.016-3.872 1.51-6.237 1.484-2.654-.022-4.688-2.568-6.21-4.826-4.259-6.34-4.707-13.768-2.076-17.721 1.861-2.803 4.807-4.449 7.572-4.449 2.817 0 4.588 1.514 6.916 1.514 2.262 0 3.638-1.517 6.896-1.517 2.464 0 5.07 1.313 6.931 3.575-6.09 3.262-5.101 11.763 1.052 14.039z"
      />
      <path
        fill="#42A5F5"
        d="M30.046 12.072c1.269-1.577 2.232-3.804 1.882-6.072-2.069.138-4.491 1.418-5.905 3.075-1.282 1.51-2.345 3.752-1.931 5.922 2.259.069 4.597-1.233 5.954-2.925z"
      />
      <path
        fill="#1E88E5"
        d="M36.736 20.421C28 30.001 20 21.001 9.228 27.842c.375 3.027 1.53 6.303 3.565 9.331 1.521 2.258 3.556 4.804 6.21 4.826 2.365.025 3.033-1.469 6.237-1.484 3.205-.024 3.814 1.5 6.176 1.482 2.656-.021 4.805-2.846 6.326-5.109 1.088-1.619 1.494-2.439 2.342-4.274-5.206-1.926-6.695-8.3-3.348-12.193z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8AppleLogo);
